import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  token: string;
};

const [useDeleteApiToken, deleteApiToken] = createAsyncAction(
  "apiTokens/delete",
  async ({ token }: Args) => {
    const res = await API.call<string>({
      endpoint: `api-tokens/${token}`,
      method: "DELETE",
      entity: API.Entity.apiToken,
    });

    return res;
  }
);
export default useDeleteApiToken;
export { deleteApiToken };
